export default __webpack_public_path__ + "ff326b8e032a5271b8936307c3d4e340.webp";